
export type SortByParam3Parameter = typeof SortByParam3Parameter[keyof typeof SortByParam3Parameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortByParam3Parameter = {
  createdAt: 'createdAt',
  title: 'title',
  level: 'level',
  instructorName: 'instructorName',
} as const;
